import { apiCustomer } from "@/api"
import { accountTokenNeedsRenewal } from "@/lib/account-token"
import { ensureGuestToken, currentGuestToken, storeGuestAccessRefresh } from "@/lib/guest-session"

let inflight: Promise<boolean> | null = null

/** Restores an expired guest or renews its current access token when due. */
export async function renewAccountTokenIfDue(): Promise<boolean> {
  const before = currentGuestToken()
  const token = await ensureGuestToken()
  if (!token) return false
  if (!before) return true
  return accountTokenNeedsRenewal() ? renewAccountToken() : false
}

/** Shares one normal access refresh and never switches guest subjects. */
export function renewAccountToken(): Promise<boolean> {
  if (!inflight) inflight = refresh().finally(() => { inflight = null })
  return inflight
}

async function refresh(): Promise<boolean> {
  const token = await ensureGuestToken()
  if (!token) return false
  try {
    const { data } = await apiCustomer.post<unknown>("/auth/refresh")
    return storeGuestAccessRefresh(data, token)
  } catch {
    return false
  }
}
